import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 路由切换后回到页面顶部；带 `#hash` 时滚到对应元素。
 *
 * SPA 不会自动滚动，缺了这一步从长页跳到短页会停在空白处。
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = decodeURIComponent(hash.slice(1));
      const target = document.getElementById(id);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
}
